'use strict';

var _ = require('lodash');
var DateTimeSettingsConfigService = function DateTimeSettingsConfigService(featureToggleService) {
  var workflowData = require('../config/datetime-settings.json');
  var entityCellRenderer = function entityCellRenderer() {
    return '<rm-combobox class="{{data.title}}" item-list="data.options" fixed-position="true" ng-model="data.value"></rm-combobox>';
  };
  var workflowColumnsDef = {
    common: [{
      headerName: 'Settings',
      field: 'name'
    }, {
      headerName: 'Value',
      field: 'value',
      cellRenderer: entityCellRenderer,
      cellRendererParams: {
        workflow: 'dashboard'
      }
    }, {
      headerName: 'Description',
      field: 'description'
    }]
  };
  function getColumnDefs(workflow) {
    var workflowDef = workflowColumnsDef[workflow];
    if (!workflowDef) {
      return false;
    }
    return workflowDef;
  }
  function getDateTimeSettings(workflow, userDefaults, isSystemDefault) {
    var settings = _.clone(workflowData[workflow]);
    if (!settings) {
      return [];
    }
    _.forEach(userDefaults, function (userSetting) {
      var workflowSetting = _.find(settings, {
        title: userSetting.name
      });
      if (workflowSetting) {
        workflowSetting["default"] = userSetting.value || '';
        workflowSetting.value = {
          id: userSetting.value
        };
      }
    });
    if (!isSystemDefault) {
      _.remove(settings, {
        title: 'timeZone'
      });
    }
    if (featureToggleService.isDisabled('REVENUE_OPTIMIZER')) {
      _.remove(settings, {
        title: 'defaultRTPView'
      });
    }
    return settings;
  }
  return {
    getColumnDefs: getColumnDefs,
    getDateTimeSettings: getDateTimeSettings
  };
};
DateTimeSettingsConfigService.$inject = ['FeatureToggleService'];
module.exports = DateTimeSettingsConfigService;